import React from "react";
import EnterprisePlanContactHeader from "./EnterprisePlanContactHeader";
import { Divider } from "antd";
import EnterprisePlanContactForm from "./EnterprisePlanContactForm";
import "./index.scss";

const EnterprisePlanContact = () => {
  return (
    <section className="dashboard-page enterprise-plan-contact-page hide-scrollbar">
      <EnterprisePlanContactHeader />
      <Divider orientation="center" style={{ margin: "0px" }} />
      <div style={{ textAlign: "center" }}>
        <h1
          style={{ fontSize: "28px", marginBottom: "10px", fontWeight: "400" }}
        >
          For <span style={{ fontWeight: "600" }}>Enterprise</span> Plans
        </h1>
        <p
          style={{
            fontSize: "16px",
            color: "#666",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          Share your details, and our sales team will reach out to you shortly!
        </p>
      </div>
      <EnterprisePlanContactForm />
    </section>
  );
};

export default EnterprisePlanContact;
